import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { Flex } from 'mds-web-ui'
import { UndoIcon, UndoCircle } from './icons'
import { transparentize } from 'polished'
import { TOOLTIP_MAIN } from '../utils/tooltipIds'

// react-pose used ms (10000); Motion uses seconds
const pathTransition = {
  pathLength: {
    ease: 'linear',
    duration: 10,
  },
}

const MotionUndoCircle = motion.create(UndoCircle)

const UndoButtonInner = React.forwardRef(
  (
    { title, size = 30, actionId: _actionId, darkMode = true, onClick },
    ref,
  ) => (
    <Flex
      as="button"
      justifyContent="center"
      alignItems="center"
      p={0}
      mx={2}
      ref={ref}
      aria-label={`Undo deleting "${title}"`}
      data-tooltip-id={TOOLTIP_MAIN}
      data-tooltip-content={`Undo deleting ${title}`}
      css={{
        position: 'relative',
        transformOrigin: '50% 50% !important',
        backgroundColor: 'transparent',
        border: 'none',
        color: 'inherit',
        borderRadius: '50%',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'all 0.2s ease',
        '&:hover, &:focus': {
          border: 'none',
          outline: 'none',
          'svg#arrow': { transform: 'scale(0.85)' },
        },
      }}
      onClick={onClick}
    >
      <MotionUndoCircle
        width={size}
        height={size}
        color={transparentize(0.5, darkMode ? '#fff' : '#000')}
        style={{ position: 'absolute', width: size, height: size }}
        initial={{ pathLength: 1 }}
        animate={{ pathLength: 0, transition: pathTransition }}
      />
      <UndoIcon
        id="arrow"
        height={18}
        width={18}
        color={darkMode ? '#fff' : '#000'}
      />
    </Flex>
  ),
)

const MotionUndoButton = motion.create(UndoButtonInner)

export const UndoButton = React.forwardRef((props, ref) => (
  <MotionUndoButton
    ref={ref}
    initial={{ scale: 0, rotate: '-90deg' }}
    animate={{ scale: 1, rotate: 0 }}
    exit={{
      scale: 0,
      rotate: '-90deg',
      transition: { scale: { delay: 0.2 }, rotate: { ease: 'linear' } },
    }}
    {...props}
  />
))

UndoButton.displayName = 'UndoButton'

export const UndoButtonWrapper = (props) => (
  <Flex flexDirection="row-reverse">
    <AnimatePresence initial={true}>{props.children}</AnimatePresence>
  </Flex>
)
